const path = '/img/products/vod-assessment';

/**
 * BANNER_DATA
 * buttonText 和 buttonLink 一一对应，默认是string，可以是是array；当是array时，渲染多个button
 */
export const BANNER_DATA = {
  title: '点播云客户价值评估工具',
  backgroundImg: `${path}/banner.webp`,
  description:
    '即刻开始体验StreamLake点播云强大的视频处理效果，并协助您计算使用点播云之后带来的全链路成本收益',
  buttonText: '立即使用',
  buttonLink: '',
  docText: '产品文档',
  backgroundImgMobile: `${path}/bannerMobile.webp`,
};

export const TECHNICAL_SUPPORT = {
  title: '技术支持',
  desc: '希望获取详细收益信息或测试您的视频处理效果，请点击【联系我们】留下联系方式，我们稍后联系您，也可点击【立即使用】体验点播云控制台的能力',
  contactUs: '联系我们',
  tyrNow: '立即使用',
};

export const VIDEO_SCENE_LIST = {
  title: '选择您的视频场景',
  subTitle:
    '查看不同的视频场景下普通转码、质臻轻流、质臻影音转码的视频处理表现',
};

export const VIDEO_TYPES = {
  origin: '原始视频',
  common: '普通转码',
  zzql: '质臻轻流',
  zzyy: '质臻影音',
};

export const VIDEO_PARAMS = {
  resolution: '分辨率',
  bitRate: '码率',
  fps: '帧率',
};

export const VIDEO_STATEMENT =
  '视频仅做我方视频画质技术处理后的效果展示，非广告性质也不代表视频中的任何人、任何公司与我方存在合作关系，如对视频的使用有疑问可联系我方处理';

export const VIDEO_TABLE_INFO = {
  origin: {
    name: '原视频',
  },
  common: {
    name: '普通转码',
    tooltip:
      '普通音视频转码，用于对视频、音频资源进行压缩编码和格式转换等常见转码操作',
  },
  zzql: {
    name: '质臻轻流',
    tooltip:
      '高压缩率音视频转码，对视频内容及场景、动作、纹理等特征进行智能感知与分析，通过视频前处理手段并配合最优编码参数，实现相同画质下码率的进一步下降',
  },
  zzyy: {
    name: '质臻影音',
    tooltip:
      '高压缩率音视频转码，对视频内容及场景、动作、纹理等特征进行智能感知与分析，通过视频前处理手段并配合最优编码参数，实现相同画质下码率的进一步下降',
  },
};

export const VIDEO_TABLE_INFO_PARAMS = {
  resolution: {
    name: '分辨率',
  },
  bitRate: {
    name: '视频码率',
  },
  KVQ: {
    name: 'KVQ',
    tooltip:
      'KVQ（Kuaishou Video Quality）是快手基于海量数据训练自研的视频质量评价体系，其不仅突破了传统算法源视频无损的限制，而且能高效评估 AI处理算法等带来的画质损失，更加符合人眼主观评价',
  },
  VMAF: {
    name: 'VMAF',
    tooltip:
      'VMAF (Visual Multimethod Assessment Fusion - 视频质量多方法评价融合) 是由Netflix公司开发的一套主观视频质量评价体系，通过引入机器学习机制，对视频进行更符合人眼视觉的质量评分',
  },
};

export const DB_CHART_CONFIG = {
  label: ['相同码率下', '质臻轻流', '画质优于', '普通转码', '视频画质'],
  series: {
    common: '普通转码 H.264',
    zzql: '质臻轻流 H.265',
  },
  xAxisName: '码率/kbps',
};

export const ASSESSMENT_CONFIG = {
  title: '收益评估',
  desc: '根据实际业务类型，通过设置业务信息、选择计费方案以评估使用StreamLake带来的全链路费用',
  selectors: {
    videoScene: {
      label: '选择视频场景',
      options: [
        { label: '短视频-UGC', value: 'UGC' },
        { label: '短视频-PGC', value: 'PGC' },
        { label: '图片电影', value: 'image' },
      ],
    },
    videoQuality: {
      label: '选择视频画质',
      targetOptions: [
        { label: '质臻轻流H.264', value: 'H264' },
        { label: '质臻轻流H.265', value: 'H265' },
      ],
      originOptions: [
        { label: '普通转码H.264', value: 'H264' },
        { label: '普通转码H.265', value: 'H265' },
      ],
    },
  },
  indicators: {
    transcode: '转码压缩率下降',
    storage: '媒体存储节约比例',
    cdn: 'CDN用量节约比例',
  },
};

export const BUSINESS_FORM_CONFIG = {
  formTitle: '设置业务数据',
  formInfo:
    '通过设置业务数据模拟您实际的视频处理及消费量级，根据您当前实际CDN计费方式选择月95计费方式或流量计费方式',
  feeTypeOptions: {
    monthBandWidth95: '月95计费',
    flow: '流量计费',
  },
  formItemOptions: {
    videoNumber: {
      label: '原视频文件数量',
      suffix: '个/月',
      message: '请输入原视频文件数量',
    },
    videoDuration: {
      label: '平均视频时长',
      suffix: '分钟',
      message: '请输入平均视频时长',
    },
    monthBandWidth95: {
      label: '月95峰值带宽',
      suffix: 'Mbps',
      message: '请输入月95峰值带宽',
    },
    flow: { label: '月流量', suffix: 'GB', message: '请输入月流量' },
  },
  extra: '注：以当前选择的视频demo作为编码阶段设置及转码压缩率参考',
  submitText: '开始计算',
};

export const ASSESSMENT_RESULT = {
  feeTimeOptionTexts: ['按月计算', '长周期计算'],
  saveRate: {
    label: '费用节约比例',
    unit: '%',
  },
  earning: {
    label: '点播全链路收益',
    unit: ['¥/月', '¥'],
  },
  schemeOne: {
    label: '方案一',
    desc: '对转码服务、媒资存储服务、CDN分发服务分别计费、构成点播云全链路总费用',
  },
  schemeTwo: {
    label: '方案二',
    desc: '归一化系数计费方案(仅收取CDN分发费用，不收取转码、媒资存储费用）',
    increaseForm: {
      increaseRate: {
        label: '年业务增长',
        suffix: '%',
      },
      period: {
        label: '评估周期',
        suffix: '年',
      },
    },
    lineChart: {
      title: '总费用',
      xAxisName: '年',
      common: '普通转码H.264',
      zzql: '质臻轻流H.265',
    },
  },
};

/**
 * todo
 * 1期 计费规格维护在前端；当前只在前端计算固定单价的费用
 * 2期 计费项规格从服务端获取；费用从服务端获取
 */
export const FeeConfigs = {
  vod: {
    prodCode: 'VOD',
    feeItems: [
      {
        feeItemName: '质臻轻流转码',
        feeType: 'static',
        metaFeeItemCode: '045fccb975c42a01',
        metaFeeItemName: '质臻轻流',
        dsls: [
          {
            price: {
              static: 0.03,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '360P',
              },
            ],
          },
          {
            price: {
              static: 0.06,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '480P',
              },
            ],
          },
          {
            price: {
              static: 0.09,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '540P',
              },
            ],
          },
          {
            price: {
              static: 0.11,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '720P',
              },
            ],
          },
          {
            price: {
              static: 0.21,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '1080P',
              },
            ],
          },
          {
            price: {
              static: 0.42,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '2K',
              },
            ],
          },
          {
            price: {
              static: 0.84,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '4K',
              },
            ],
          },
          {
            price: {
              static: 0.24,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '360P',
              },
            ],
          },
          {
            price: {
              static: 0.36,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '480P',
              },
            ],
          },
          {
            price: {
              static: 0.42,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '540P',
              },
            ],
          },
          {
            price: {
              static: 0.6,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '720P',
              },
            ],
          },
          {
            price: {
              static: 1.2,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '1080P',
              },
            ],
          },
          {
            price: {
              static: 2.1,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '2K',
              },
            ],
          },
          {
            price: {
              static: 4.2,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '4K',
              },
            ],
          },
        ],
      },
      {
        feeItemName: '视频转码',
        feeType: 'static',
        metaFeeItemCode: '04599981b3ce454d',
        metaFeeItemName: '普通转码',
        dsls: [
          {
            price: {
              static: 0.01,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '360P',
              },
            ],
          },
          {
            price: {
              static: 0.02,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '480P',
              },
            ],
          },
          {
            price: {
              static: 0.03,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '540P',
              },
            ],
          },
          {
            price: {
              static: 0.035,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '720P',
              },
            ],
          },
          {
            price: {
              static: 0.07,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '1080P',
              },
            ],
          },
          {
            price: {
              static: 0.14,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '2K',
              },
            ],
          },
          {
            price: {
              static: 0.28,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H264',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '4K',
              },
            ],
          },
          {
            price: {
              static: 0.08,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '360P',
              },
            ],
          },
          {
            price: {
              static: 0.12,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '480P',
              },
            ],
          },
          {
            price: {
              static: 0.14,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '540P',
              },
            ],
          },
          {
            price: {
              static: 0.2,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '720P',
              },
            ],
          },
          {
            price: {
              static: 0.4,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '1080P',
              },
            ],
          },
          {
            price: {
              static: 0.7,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '2K',
              },
            ],
          },
          {
            price: {
              static: 1.4,
            },
            factors: [
              {
                name: '编码方式',
                type: 'codeType',
                val: 'H265',
              },
              {
                name: '转码规格',
                type: 'transcodeType',
                val: '4K',
              },
            ],
          },
        ],
      },
      {
        feeItemName: '流量中国大陆',
        feeType: 'static',
        metaFeeItemCode: '045fcef42b1390ds',
        metaFeeItemName: '流量',
        dsls: [
          {
            price: {
              static: 0.21,
            },
            factors: [],
          },
        ],
      },
      {
        feeItemName: 'CDN加速',
        feeType: 'static',
        metaFeeItemCode: '045fcef42b9274px',
        metaFeeItemName: '月95峰值带宽',
        dsls: [
          {
            price: {
              static: 18,
            },
            factors: [],
          },
        ],
      },
      {
        feeItemName: '存储',
        feeType: 'static',
        metaFeeItemCode: '045fcf7cbec42730',
        metaFeeItemName: '存储',
        dsls: [
          {
            price: {
              static: 0.12,
            },
            factors: [
              {
                name: '存储方式',
                type: 'storageMode',
                val: '标准存储',
              },
            ],
          },
          {
            price: {
              static: 0,
            },
            factors: [
              {
                name: '存储方式',
                type: 'storageMode',
                val: '低频存储',
              },
            ],
          },
        ],
      },
    ],
  },
};
